import React, {useEffect, useState} from 'react';
import {Line} from 'react-chartjs-2';
import moment from 'moment';


const LineChart = ({moneyLogs, usersMap}) => {
    const [chartData, setChartData] = useState([]);
    const [dataInfo, setDataInfo] = useState(new Map());
    const [totalMoney, setTotalMoney] = useState("");


    useEffect(() => {
        if (moneyLogs.length > 0) {
            const toDateLogs = moneyLogs.map(ml => {
                return {...ml, date: moment(ml.date)}
            })
            const sortedMoneyLogs = toDateLogs.sort((a, b) => a.date - b.date);

            const infoMap = new Map();
            const labels = [];
            const data = [];
            let i = 0;
            let total = 0;

            sortedMoneyLogs.forEach(ml => {
                total += ml.amount;
                let m = moment(ml.date);
                let label = m.format("DD MMM");

                if (infoMap[label]) {
                    infoMap[label].push(ml);
                    data[i - 1] = total
                } else {
                    infoMap[label] = [ml];
                    labels.push(label);
                    data.push(total);
                    i++;
                }
            });

            setDataInfo(infoMap);
            setTotalMoney(total);

            setChartData({
                labels: labels,
                datasets: [
                    {
                        label: "Money Count",
                        data: data,
                        borderColor: "#0288d1",

                    }
                ],
            });
        }
    }, [moneyLogs])


    return <Line type={"line"} data={chartData} options={{
        responsive: true,
        plugins: {
            title: {
                display: true,
                text: ['Amount of Money by Date', `Current Total Money: ${Number.isFinite(totalMoney) ? Number(totalMoney).toFixed(2) : totalMoney}TL`],
                font: {size: 20}
            },
            tooltip: {
                callbacks: {
                    label: (context) => {
                        return "Total Money: " + context.formattedValue + "TL"
                    },
                    footer: function (context) {
                        let logs = dataInfo[context[0].label];
                        let total = 0;
                        let labels = logs.map(log => {
                            let user = usersMap[log.userID];
                            total += log.amount;
                            return user.name + " " + user.surname + ": " + log.amount.toFixed(2) + "TL At: " + log.date.format("HH:mm");
                        })
                        labels.push("Day Result: " + total.toFixed(2) + "TL")
                        return labels
                    }
                },
                displayColors: false
            }
        }
    }}/>

}

export default LineChart;